<template>
 <div class="ui vertical segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui container">
    <div :class="[{'vuetable-wrapper ui basic segment': true}, loading]">
      <div id="demo" class="ui vertical stripe segment">
        <div id="content" class="ui basic segment">
          <h4 class="ui header">Update Cross Reference</h4>
        
       
                 
            <vuetable ref="vuetable"
                api-url= "corssreference/"
                :http-options="httpOptions"
                :http-fetch="fetchDataForUpdateCrossReference"
                :fields="fields"
                :table-height="tableHeight"
                pagination-path="pagination"
                :per-page="perPage"
                :append-params="moreParams"
                detail-row-component="corssreference-detail-row"
                detail-row-transition="expand"
                :row-class="rowClassCB"
                @vuetable:load-success="onLoadSuccess"
                 @vuetable:load-error="onLoadError"
                @vuetable:loading="showLoader"
                @vuetable:loaded="hideLoader"
                @vuetable:cell-clicked="onCellClicked"
                @vuetable:initialized="onInitialized"
                @vuetable:data-reset="onDataReset"
                track-by="id">
              </vuetable>

             
            <div >
            <br />
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Community &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                       <select class="ui input" :disabled="loaded == 2" style="width:300px"  v-model="communitySelected"  >
                      <option v-for="community in communities" v-bind:value="community.community_id" v-bind:key="community.community_id" >
                          {{ community.community_name }}
                      </option>
                    </select>
                    </div>
                  </div>
            </div>

            <!--
            <div >
            <br />
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Doc Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                       <select class="ui input" : style="width:300px"  v-model="documentTypeSelected"  >
                      <option v-for="documenttype in documenttypes" v-bind:value="documenttype.doctype_code" v-bind:key="documenttype.doctype_code" >
                          {{ documenttype.description }}
                      </option>
                    </select>
                    </div>
                  </div>
            </div>
          
            -->

            <div >
            <br />
            <div class="ui left aligned nine wide column">
                      <div class="ui labeled icon input">
                        <div class="ui label">Doc Type &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </div>
                       <select class="ui input" style="width:300px"  v-model="documentTypeSelected" @change="documentTypeChangedValue()" >
                      <option v-for="documenttype in documenttypes" v-bind:value="documenttype.doctype_id" v-bind:key="documenttype.doctype_id" >
                          {{ documenttype.description }}
                      </option>
                    </select>
                     </div>
              </div>
            </div>






            <div >
            <br />
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Route &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                      <select class="ui dropdown"  name="route" style="width:300px"  v-model="routeSelected" @change="routeChangedValue()"> 
                      <option v-for="route in routes" v-bind:value="route.routing_id" v-bind:key="route.routing_id" >
                        {{ route.description }}
                      </option>
                      </select>
                    </div>
                  </div>
            </div>

           <div >
            <br />
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Currency &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp;&nbsp; </div>
                      <select class="ui dropdown" style="width:300px" name="currency" v-model="currencySelected" @change="currencyChangedValue()">
                      <option v-for="currency in currencies" v-bind:value="currency.currency_type_code" v-bind:key="currency.currency_type_code" >
                            {{ currency.currency_type_code }}
                        </option>
                      </select>
                    </div>
                  </div>
            </div>


            <div >
            <br />
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Corcentric Code  </div>
                      <input placeholder="Corcentric Code" @change="clearMessage()" style="width:300px" name="_corcentriccode" type="text"  ref="ipCorcentricCode" required  >
                       <div class="ui red label" v-if="isEmpty" >
                          Please enter Corcentric Code.
                       </div>
                    </div>
                  </div>
             <br />
            </div>
             
          <div class="ui primary submit button"   @click="updateCorssReference()">Update Cross Reference</div>
          <div class="ui button"  @click="closeWindow()">Close Current Window</div>
          
        

          <div class="ui modal">
            <i class="close icon"></i>
            <div class="header">
             Do you want to continue?
            </div>
            <div class="actions">
              <div class="ui black deny button">
              Nope
              </div>
              <div class="ui positive right labeled icon button">
              Yes
              <i class="checkmark icon"></i>
              </div>
            </div>
          </div>





          
        </div><!-- content -->
      </div><!-- app -->
      </div><!-- vuetable-wrapper -->
    </div><!-- ui container -->
  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/components/vuetable-2/Vuetable.vue'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropdown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'
import Vue from 'vue'
import Header from '@/components/Header.vue';
import CorssRefDetailRow from './CrossReferenceDetailRow.vue'
import UpdateCrossReferenceData from './UpdateCrossReferenceData'


let E_SERVER_ERROR = 'Error communicating with the server'

Vue.component('Update-Cross-Reference-Data',UpdateCrossReferenceData)
Vue.component('corssreference-detail-row', CorssRefDetailRow)

let tableColumns = [
  {
    name: 'id',
    title: '<i class="unordered list icon"></i>',
    dataClass: 'left aligned',
    width: '25px',
    callback: 'showDetailRow'
  },
  {
    name: 'sellerRcvCode',
    title: 'Vendor Code',
    dataClass: 'left aligned',
    width: '75px'
  },
  {
    name: 'agencyRcvCode',
    dataClass: 'left aligned',
    title: 'Buyer Code',
    width: '73px'
 },
 {
    name: 'shopRcvCode',
    title: 'Location Code',
    width: '73px',
    dataClass: 'left aligned'
 },
 {
    name: 'ccCorcentricCode',
    title: 'Corcentric Code',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '83px'
 },
 {
    name: 'currencyCode',
    title: 'Curr Code',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '50px'
  },
  {
    name: 'communityCode',
    title: 'Community Code',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '70px'
  }
]

export default {
    components: {
    appHeader: Header,
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationInfo
  },
  data () {
    return {
    input: {
      refreshtoken : ""
    } ,
    diffMins : 0,
    refreshToken_Event_Fired : 0 ,
    showMenu : false,
    tokenExpired : 0,
    communities : [],
    communitySelected : "",
    httpOptions: {
      headers: {
      authorization: ""
      }
    },
    loading: '',
    BuyerCode : '',
    VendorCode : '',
    CorcentricCode : '',
    moreParams: { _filter : '' , _buyer_code : '',_vendor_code : '',_loc_code : '', _corc_code : ''},
    fields: tableColumns,
    tableHeight: '',
    vuetableFields: false,
    paginationComponent: 'vuetable-pagination',
    perPage: 10,
    paginationInfoTemplate: 'Showing record: {from} to {to} from {total} item(s)',
    communityId : "",
    routes :[],
    routeSelected : "",
    routing_id : "",
    xrefId : "",
    loaded : 1,
    isEmpty : false,
    currencies : [],
    currencySelected : "",
     documenttypes :[],
    documentTypeSelected : "",
    doctypeCode:""
 }
  },
  watch: {
    'perPage' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    'paginationComponent' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination)
      })
    }
  },
  created(){
    if(!localStorage.getItem('id_token')){
    this.$router.push({name: 'Login'});
    }else{
    this.checkTokenExpired();
    /*Get ids from query string */
    this.doctypeCode = CryptoJS.AES.decrypt( this.$route.query.code, 'corcentric').toString(CryptoJS.enc.Latin1);
    this.moreParams['filter'] = CryptoJS.AES.decrypt( this.$route.query.xrefid, 'corcentric').toString(CryptoJS.enc.Latin1);
    this.communityId = CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1);
    this.xrefId = CryptoJS.AES.decrypt( this.$route.query.xrefid, 'corcentric').toString(CryptoJS.enc.Latin1);
   
    this.bindCommunity();
    this.bindRoutes();
   
    this.bindCurrency();

     this.bindDocumentType(); 
    }
  
  },
  methods: {
    bindCommunity(){
    if(localStorage.getItem('id_token')){
      axios({ method: "GET", "url": Vue.prototype.$hostname +  "lookup/community", 
            "headers": 
            { 
              "content-type": "application/json",
              "authorization": "bearer " + localStorage.getItem('id_token') 
            } }).then
            (
                result => {
                this.communities = result.data;
                this.communitySelected =  CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1);
                this.loaded = 2;
                }, 
            error => {
                console.error(error);
                this.sessionExpired(error.response.status);
            });
      } 
    },
     bindRoutes(){
      axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/routing/" , 
      "headers": 
        { 
          "content-type": "application/json",
          "authorization": "bearer " + localStorage.getItem('id_token') 
        } }).then
        (
          result => {
              this.routes = result.data;
              this.loaded = 2;
          }, 
        error => {
            console.error(error);
              this.sessionExpired(error.response.status);
        });
   },
   routeChangedValue(){
      this.checkTokenExpired();
   },
   currencyChangedValue(){
    this.checkTokenExpired();
   },
   clearMessage(){
    this.isEmpty = false; 
   },
   closeWindow(){
      window.close();
   },
   updateCorssReference(){
      if(this.$refs.ipCorcentricCode.value.trim() != ''){
        this.isEmpty = false;     
        swal({
        title: "",
        text: "Are you sure, to update Corss Reference & Route?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Update it!",
        closeOnConfirm: true
        },() => {
         
          axios({ method: "POST", "url": Vue.prototype.$hostname +  "updatecrossreferencebyid", 
            "data": {
              xref_id : this.xrefId ,
              community_id : this.communitySelected,
              routing_id : this.routeSelected,
              corcentric_code : this.$refs.ipCorcentricCode.value.trim() ,
              currency_code  :  this.currencySelected,
              currency_id :  this.currencies.filter(x=> x.currency_type_code=== this.currencySelected)[0].currency_type_id  ,
              doctype_id : this.documentTypeSelected       
            }, 
            "headers": 
            { 
              "content-type": "application/json" ,
              "authorization": "bearer " + localStorage.getItem('id_token') 
            }  }).then
            (
              result => {
                sweetAlert('Data has been updated successfully!', '', 'success')
              }, 
            error => {
            console.error(error);
            this.sessionExpired(error.response.status);
            sweetAlert('Something\'s Wrong!', error, 'error')
            });
      
        
      })
      }else this.isEmpty = true; 
    },
    sessionExpired(errorStatus){
      if ((errorStatus === 403 || errorStatus === 401) && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!')
      }
    },
    transform (data) {
      let transformed = {}
      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to
      }

      transformed.data = []
      data = data.data

      for (let i = 0; i < data.length; i++) {
        transformed['data'].push({
          id: data[i].id,
          XrefId: data[i].XrefId,
          sellerRcvCode : data[i].sellerRcvCode,
          agencyRcvCode: data[i].agencyRcvCode,
          shopRcvCode: data[i].shopRcvCode,
          ccCorcentricCode: data[i].ccCorcentricCode,
          currencyCode : data[i].currencyCode,
          communityCode: data[i].communityCode,
          MemberName: data[i].MemberName,
          Doctype: data[i].Doctype,
          Routing:data[i].Routing,
          routingId:data[i].routingId
          })

         this.currencySelected = data[i].currencyCode,
         this.routeSelected = data[i].routingId,
         this.$refs.ipCorcentricCode.value =  data[i].ccCorcentricCode,
         this.doctypeCode = data[i].Doctype

      
         //this.documentTypeSelected = this.documenttypes.filter(x=> x.doctype_code == this.doctypeCode)[0].doctype_id ;
         
          //this.documentTypeSelected =  this.documenttypes.filter(x=> x.doctype_code === data[i].Doctype)[0].doctype_id;

         

      }

      return transformed
    },
    bindCurrency(){
     axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/currency/" , 
    "headers": 
      { 
        "content-type": "application/json",
        "authorization": "bearer " + localStorage.getItem('id_token') 
      } }).then
      (
        result => {
            this.currencies = result.data;
        }, 
      error => {
          console.error(error);
            this.sessionExpired(error.response.status);
      });
    },
    bindDocumentType(){
        if(localStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/documenttype", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.documenttypes = result.data;
                    this.documentTypeSelected =this.documenttypes.filter(x=> x.doctype_code == this.doctypeCode)[0].doctype_id ;
                    //this.documentTypeSelected  = "-1";
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });

                
        } 
    },
    documentTypeChangedValue(){
      this.checkTokenExpired();
    },
    fetchDataForUpdateCrossReference:function(apiUrl, httpOptions) {
    this.checkTokenExpired();
    this.httpOptions.headers['authorization'] = 'bearer ' +  localStorage.getItem('id_token')
    return axios.get(Vue.prototype.$hostname + apiUrl + CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1) + "/N" , this.httpOptions); 
    },
    checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
          this.refreshToken_Event_Fired = 0;
          console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
     showSettingsModal () {
      let self = this
      $('#settingsModal').modal({
        detachable: true,
        onVisible () {
          $('.ui.checkbox').checkbox()
        }
      }).modal('show')
    },
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    showDetailRow (value) {
    let icon = this.$refs.vuetable.isVisibleDetailRow(value) ? 'down' : 'right'
    return [
        '<a class="show-detail-row">',
            '<i class="chevron circle ' + icon + ' icon"></i>',
        '</a>'
      ].join('')
    },
    setFilter () {
      this.$refs.vuetable.refresh();
    },
    resetFilter () {
      this.CorcentricCode = null;
      this.BuyerCode = null;
      this.VendorCode = null;
      this.communitySelected = "-1";
      this.setFilter()
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
        )
    },
    rowClassCB (data, index) {
      return (index % 2) === 0 ? 'odd' : 'even'
    },
    onCellClicked (data, field, event) {
      this.checkTokenExpired();
      console.log('cellClicked', field.name)
      if (field.name !== '__actions') {
        this.$refs.vuetable.toggleDetailRow(data.id)
      }
    },
    onCellDoubleClicked (data, field, event) {
      console.log('cellDoubleClicked:', field.name)
    },
    onCellRightClicked (data, field, event) {
      console.log('cellRightClicked:', field.name)
    },
    onLoadSuccess (response) {
     // set pagination data to pagination-info component
      this.$refs.paginationInfo.setPaginationData(response.data)
      let data = response.data.data
      if (this.searchFor !== '') {
        for (let n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name)
          data[n].email = this.highlight(this.searchFor, data[n].email)
        }
      }
    },
    onLoadError (response) {
      if (response.status == 400 &&  this.tokenExpired === 0) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error')
        his.$router.push({name: 'Login'});
      } else if (response.status == 403 || response.status == 401) {
        this.sessionExpired(response.status)
      }else {
       /* if(this.tokenExpired === 0){sweetAlert('Oops', E_SERVER_ERROR, 'error')*/
        this.$router.push({name: 'Login'});
       /* }*/
      }
    },
    onPaginationData (tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination)
      this.$refs.pagination.setPaginationData(tablePagination)
    },
    onChangePage (page) {
            this.$refs.vuetable.changePage(page)
    },
    onInitialized (fields) {
      console.log('onInitialized', fields)
      this.vuetableFields = fields
    },
    onDataReset () {
      console.log('onDataReset')
      thonInitializedis.$refs.paginationInfo.resetData()
      this.$refs.pagination.resetData()
    }

  }
}
</script>
 <style type="text/css">
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .secondary.pointing.menu .toc.item {
        display: none;
      }
      .vuetable {
        margin-top: 1em !important;
      }
      .vuetable-wrapper.ui.basic.segment {
        padding: 0em;
      }
      .vuetable button.ui.button {
        padding: .5em .5em;
        font-weight: 400;
      }
      .vuetable button.ui.button i.icon {
        margin: 0;
      }
      .vuetable td i.handle-icon:hover {
        cursor: pointer;
      }
      .vuetable-actions {
        width: 15%;
        padding: 12px 0px;
        text-align: center;
      }
      .vuetable-pagination {
        background: #f9fafb !important;
      }
      .vuetable-pagination-info {
        margin-top: auto;
        margin-bottom: auto;
      }
      .highlight {
        background-color: yellow;
      }
      .vuetable-detail-row {
        height: 200px;
      }
      .detail-row {
        margin-left: 40px;
      }
      .expand-transition {
        transition: all .5s ease;
      }
      .expand-enter, .expand-leave {
        height: 0;
        opacity: 0;
      }
      tr.odd {
        background-color: #e6f5ff;
      }
      body {
        overflow-y: scroll;
      }
    </style>

 
 
    



// WEBPACK FOOTER //
// src/components/integration-staging/UpdateCrossReferenceData.vue